import { JSX } from 'solid-js';

const PortalRoot = (props: { id?: string }) => {
  return <div id={props.id}></div>;
};

const PortalWithId = (props: { id: string; children: JSX.Element }) => {
  return <Portal mount={document.getElementById(props.id) ?? undefined}>{props.children}</Portal>;
};

export { PortalRoot, PortalWithId };
